/* eslint-disable no-restricted-syntax */
import Command from '@ckeditor/ckeditor5-core/src/command';
import { Writer, Editor } from '@ckeditor/ckeditor5-core/src/editor';
import { CommentService } from 'components/organisms/document/services/comment';

export const CommentIdAttibute = 'commentid';
export const CommentTypeAttibute = 'commenttype';
export const CommentActiveAttibute = 'commentactive';
export const INTERMEDIATE_COMMENT = 'INTERMEDIATE';
interface CommandOptions {
  commentId: string;
  commentType: string;
}

const getRange = (selection, writer) => {
  const ranges = [...selection.getRanges()];
  const offsetRanges: any[] = [];

  for (const range of ranges) {
    const isWholeTableCellSelected =
      range.start.parent.parent.name === 'tableCell' && range.start.isAtStart;

    if (isWholeTableCellSelected) {
      /**
       * if the whole table cell is selected and if the comment is added
       * for eg in here <td>sample</td>
       * if `sample` is selected and comment is added cke editor is deleting it after some time
       * Any span tag is getting removing by CKE. We couldn't pin point of root cause.
       * However, there is an empty space(any char for that matter), the comment is retained:
       * for eg <td> sample</td> notice an empty space before `sample`. In this case the comment is retained.
       *
       * so we are using an zero width space. This way user can't delete the empty space as an annoyance and cke isn't removing comment.
       */
      const position = selection.getFirstPosition();

      // inserting a zero width space because user can't delete the space as well as comment is retained
      writer.insertText('\u200B', position);
      offsetRanges.push(
        writer.createRange(
          range.start.getShiftedBy(1),
          range.end.getShiftedBy(1),
        ),
      );
    } else {
      offsetRanges.push(range);
    }
  }

  return offsetRanges;
};

export class InsertCommentCommand extends Command {
  editor: Editor;

  valueId: string;

  isEnabled: boolean;

  constructor(editor: Editor) {
    super(editor);
    this.editor = editor;
    this.valueId = '';
    this.isEnabled = false;
  }

  async execute(options: CommandOptions): Promise<void> {
    const { commentId, commentType } = options;
    const { model } = this.editor;
    const { document } = model;
    const { selection } = document;

    model.change((writer: Writer) => {
      const ranges = model.schema.getValidRanges(
        getRange(selection, writer),
        CommentIdAttibute,
      );

      if (selection.isCollapsed) {
        const position = selection.getFirstPosition();

        // When selection is inside text with `comment` attribute.
        if (selection.hasAttribute(CommentIdAttibute)) {
          // Find the full commented range.
          const isSamecomment = (val) =>
            val.item.hasAttribute(CommentIdAttibute) &&
            val.item.getAttribute(CommentIdAttibute) === this.valueId;

          const commentStart = position.getLastMatchingPosition(isSamecomment, {
            direction: 'backward',
          });
          const commentEnd = position.getLastMatchingPosition(isSamecomment);

          const commentRange = writer.createRange(commentStart, commentEnd);

          // Then depending on current value...
          if (!commentId || this.valueId === commentId) {
            // remove attribute when passing value different then current
            //  or executing 'eraser'
            writer.removeAttribute(CommentIdAttibute, commentRange);
            writer.removeSelectionAttribute(CommentIdAttibute);
          } else {
            // ...update `commentId` value.
            writer.setAttribute(CommentIdAttibute, commentId, commentRange);
            writer.setSelectionAttribute(CommentIdAttibute, commentId);
          }
        } else if (commentId) {
          writer.setSelectionAttribute(CommentIdAttibute, commentId);
        }
      } else {
        for (const range of ranges) {
          if (commentId) {
            writer.setAttribute(CommentIdAttibute, commentId, range);
            writer.setAttribute(CommentTypeAttibute, commentType, range);
          } else {
            writer.removeAttribute(CommentIdAttibute, range);
            writer.removeAttribute(CommentTypeAttibute, range);
          }
        }
      }
    });
  }

  refresh(): void {
    const { model } = this.editor;
    const { selection } = model.document;

    this.valueId = selection.getAttribute(CommentIdAttibute);
    if (this.valueId) {
      CommentService.sendData(this.valueId);
    }
    const isPossibleToAdd = model.schema.checkAttributeInSelection(
      selection,
      CommentIdAttibute,
    );

    // getLastPosition returns 0 always if selects with triple click.
    // remove the code if we're not getting any other bugs when commenting.
    // const isTextSelected =
    //   selection.getFirstPosition().offset !==
    //   selection.getLastPosition().offset;

    this.isEnabled = isPossibleToAdd;
  }
}
